import { AppState } from "../reducer";

export const currentErrorAction = (state: AppState) => state.shell.errorAction;